/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Daily_Extra_TitleInputs */

const en_daily_extra_title = /** @type {(inputs: Daily_Extra_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daily Extra Boxes`)
};

const ar_daily_extra_title = /** @type {(inputs: Daily_Extra_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`صناديق كعك إضافية يومية`)
};

const de_daily_extra_title = /** @type {(inputs: Daily_Extra_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tägliche zusätzliche Kuchenboxen`)
};

const es_daily_extra_title = /** @type {(inputs: Daily_Extra_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cajas de pasteles extra diarias`)
};

const fr_daily_extra_title = /** @type {(inputs: Daily_Extra_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boîtes à gâteaux supplémentaires quotidiennes`)
};

const it_daily_extra_title = /** @type {(inputs: Daily_Extra_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scatole di torte extra giornaliere`)
};

const ja_daily_extra_title = /** @type {(inputs: Daily_Extra_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`毎日の追加ケーキボックス`)
};

const ko_daily_extra_title = /** @type {(inputs: Daily_Extra_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`일일 추가 케이크 상자`)
};

const pt_br_daily_extra_title = /** @type {(inputs: Daily_Extra_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caixas de bolo extras diárias`)
};

const ru_daily_extra_title = /** @type {(inputs: Daily_Extra_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ежедневные дополнительные коробки с тортом`)
};

const th_daily_extra_title = /** @type {(inputs: Daily_Extra_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กล่องเค้กเพิ่มเติมรายวัน`)
};

const tr_daily_extra_title = /** @type {(inputs: Daily_Extra_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Günlük Ekstra Pasta Kutuları`)
};

const zh_cn_daily_extra_title = /** @type {(inputs: Daily_Extra_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每日额外蛋糕盒`)
};

const zh_tw_daily_extra_title = /** @type {(inputs: Daily_Extra_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每日額外蛋糕盒`)
};

/**
* | output |
* | --- |
* | "Daily Extra Boxes" |
*
* @param {Daily_Extra_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const daily_extra_title = /** @type {((inputs?: Daily_Extra_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Daily_Extra_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_daily_extra_title(inputs)
	if (locale === "ar") return ar_daily_extra_title(inputs)
	if (locale === "de") return de_daily_extra_title(inputs)
	if (locale === "es") return es_daily_extra_title(inputs)
	if (locale === "fr") return fr_daily_extra_title(inputs)
	if (locale === "it") return it_daily_extra_title(inputs)
	if (locale === "ja") return ja_daily_extra_title(inputs)
	if (locale === "ko") return ko_daily_extra_title(inputs)
	if (locale === "pt_br") return pt_br_daily_extra_title(inputs)
	if (locale === "ru") return ru_daily_extra_title(inputs)
	if (locale === "th") return th_daily_extra_title(inputs)
	if (locale === "tr") return tr_daily_extra_title(inputs)
	if (locale === "zh_cn") return zh_cn_daily_extra_title(inputs)
	return zh_tw_daily_extra_title(inputs)
});